import React from 'react';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      top: -43,
      position: 'absolute',
    },
  })
);

interface BackBtnProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function BackBtn(props: BackBtnProps) {
  const classes = useStyles();

  return (
    <Button
      color="primary"
      variant="contained"
      onClick={props.onClick}
      className={classes.button}
    >
      <div
        css={`
          gap: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
        `}
      >
        <ArrowBack />
        Back
      </div>
    </Button>
  );
}
